// extracted by mini-css-extract-plugin
module.exports = {"container":"components-questionFooter-questionFooter__container--iEyQx","link":"components-questionFooter-questionFooter__link--2iLgm"};